module.exports = __webpack_public_path__ + "static/img/exclusive-modal-bg.5041464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exclusive-modal-bg.png
// module id = 1029
// module chunks = 0 18 20 21 22 23 25 28 29 36 37 38 41 42 44 45 46 48 49